export default __webpack_public_path__ + "static/media/tiny-faces-nft-preview.7759c05f.png";